export default __webpack_public_path__ + "static/modal04_02-pc-26a33308a8fc5041c675051fea1c8928.png";